import { Flex } from '@chakra-ui/react';
import { ColDef } from 'ag-grid-community';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { SingleValueSelect } from '../../components/cellComponents/SingleValueSelect';
import { VIEW_EDIT_TABLE_ROLES } from '../roles';

type ColDefs = Array<ColDef>;

export const viewEditObjectivesTableColDefs: ColDefs = [
  {
    headerName: 'Name',
    field: 'name',
    width: 200,
    editable: false,
    sortable: true,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%" justifyContent="flex-start">
        <TextBodyMedium>{params.value}</TextBodyMedium>
      </Flex>
    ),
    filter: 'agSetColumnFilter',
    filterParams: {
      values: VIEW_EDIT_TABLE_ROLES.map((role) => role.name),
      suppressSorting: true,
    },
  },
  {
    headerName: 'Edit',
    field: 'editObjectives',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'Delete',
    field: 'deleteObjectives',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'Update status/progress',
    field: 'updateStatusProgressObjectives',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'View/Comment',
    field: 'viewCommentObjectives',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
];

export const viewEditKeyResultsTableColDefs: ColDefs = [
  {
    headerName: 'Name',
    field: 'name',
    width: 200,
    editable: false,
    sortable: true,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%" justifyContent="flex-start">
        <TextBodyMedium>{params.value}</TextBodyMedium>
      </Flex>
    ),
    filter: 'agSetColumnFilter',
    filterParams: {
      values: VIEW_EDIT_TABLE_ROLES.map((role) => role.name),
      suppressSorting: true,
    },
  },
  {
    headerName: 'Edit',
    field: 'editKeyResults',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'Delete',
    field: 'deleteKeyResults',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'Update status/progress',
    field: 'updateStatusProgressKeyResults',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'View/Comment',
    field: 'viewCommentKeyResults',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
];

export const viewEditInitiativesTableColDefs: ColDefs = [
  {
    headerName: 'Name',
    field: 'name',
    width: 200,
    editable: false,
    sortable: true,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%" justifyContent="flex-start">
        <TextBodyMedium>{params.value}</TextBodyMedium>
      </Flex>
    ),
    filter: 'agSetColumnFilter',
    filterParams: {
      values: VIEW_EDIT_TABLE_ROLES.map((role) => role.name),
      suppressSorting: true,
    },
  },
  {
    headerName: 'Edit',
    field: 'editInitiatives',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'Delete',
    field: 'deleteInitiatives',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'Update status/progress',
    field: 'updateStatusProgressInitiatives',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'View/Comment',
    field: 'viewCommentInitiatives',
    flex: 1,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect tableType="rolesToViewUpdateStatusEditDeleteConfig" {...params} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
];
